import { render, staticRenderFns } from "./produit.vue?vue&type=template&id=249709e3&scoped=true&"
import script from "./produit.vue?vue&type=script&lang=js&"
export * from "./produit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249709e3",
  null
  
)

export default component.exports